// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3C68p","range":"MonthRangeSwitch_range__3ZAEX","disabled":"MonthRangeSwitch_disabled__2boE3"};